import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(logo) {
  return yield oncallFetch("/api/oncall/administration/partners/get-logo", {
    logo,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/administration/partners/get-logo.js